export interface ApiErrorDetail {
  type: string;
  detail: string;
}

export class ApiClientError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = "ApiClientError";
  }
}

interface ApiClientErrorOptions {
  url: string;
  method: string;
  status: number;
  cause?: unknown;
  errors?: ApiErrorDetail[];
}

export class ApiError extends ApiClientError {
  readonly url: string;
  readonly method: string;
  readonly status: number;
  readonly errors: ApiErrorDetail[];

  constructor({ url, method, status, cause, errors = [] }: ApiClientErrorOptions) {
    const base = `${method} ${url} failed with status ${status}`;
    const detail = errors.length ? `: ${errors.map((e) => e.detail).join("; ")}` : "";
    super(`${base}${detail}`, { cause });
    this.name = "ApiError";
    this.url = url;
    this.method = method;
    this.status = status;
    this.errors = errors;
  }
}

// fetch() itself rejected — no response was ever received (offline, DNS failure, CORS, aborted).
export class ApiConnectionError extends ApiClientError {
  readonly type = "CLIENT_CONNECTION_ERROR";

  constructor(
    message: string,
    readonly cause?: unknown,
  ) {
    super(message, { cause });
    this.name = "ApiConnectionError";
  }
}
